import { render, staticRenderFns } from "./AgendaAtividades.vue?vue&type=template&id=6afc60e8&scoped=true"
import script from "./AgendaAtividades.vue?vue&type=script&lang=js"
export * from "./AgendaAtividades.vue?vue&type=script&lang=js"
import style0 from "./AgendaAtividades.vue?vue&type=style&index=0&id=6afc60e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6afc60e8",
  null
  
)

export default component.exports